import * as categoryActions from '../redux/actions/categoriesActions.Thunks';
import * as currentUserActions from '../redux/actions/currentUserActions.Thunks';
import { useAuthN } from '../authN/useAuthN';
import { useDispatch, useSelector } from 'react-redux';

export const useCategoriesLogic = () => {
	const user = useSelector((state) => state.user);
	const dispatch = useDispatch();
	const { getAccessToken, isInProgress, isAuthenticated } = useAuthN();

	const getCategories = async () => {
		if (isAuthenticated && !isInProgress) {
			const atResponse = await getAccessToken(APIS.lp.scopes);
			const categories = await dispatch(
				categoryActions.getCategories(atResponse.accessToken, user.enterpriseProfileId)
			);
			return categories;
		}
	};

	const createCategory = async (newCategory) => {
		if (isAuthenticated && !isInProgress) {
			const atResponse = await getAccessToken(APIS.lp.scopes);
			try {
				await dispatch(categoryActions.createCategory(atResponse.accessToken, user.enterpriseProfileId, newCategory));
				return true;
			} catch {
				return false;
			}
		}
	};

	const updateCategoryOrder = async (category) => {
		if (isAuthenticated && !isInProgress) {
			const atResponse = await getAccessToken(APIS.lp.scopes);
			await dispatch(categoryActions.updateCategoryOrder(atResponse.accessToken, user.enterpriseProfileId, category));
		}
	};

	const updateCategoryName = async (updatedCategory) => {
		if (isAuthenticated && !isInProgress) {
			const atResponse = await getAccessToken(APIS.lp.scopes);
			try {
				await dispatch(
					categoryActions.updateCategoryName(atResponse.accessToken, user.enterpriseProfileId, updatedCategory)
				);
				return true;
			} catch {
				return false;
			}
		}
	};

	const deleteCategory = async (categoryId) => {
		if (isAuthenticated && !isInProgress) {
			const atResponse = await getAccessToken(APIS.lp.scopes);
			try {
				await dispatch(categoryActions.deleteCategory(atResponse.accessToken, user.enterpriseProfileId, categoryId));
				return true;
			} catch {
				return false;
			}
		}
	};

	const updateCollapsedCategories = async (collapsedCategories) => {
		if (isAuthenticated && !isInProgress) {
			const atResponse = await getAccessToken(APIS.lp.scopes);
			try {
				await dispatch(
					currentUserActions.updateCollapsedCategories(
						atResponse.accessToken,
						user.enterpriseProfileId,
						collapsedCategories
					)
				);
				return true;
			} catch {
				return false;
			}
		}
	};

	return {
		getCategories,
		createCategory,
		updateCategoryOrder,
		updateCategoryName,
		deleteCategory,
		updateCollapsedCategories
	};
};
